'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$() {
  this.aF7 = null;
  this.aF8 = false;
}
export { $c_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$ as $c_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$ };
$p = $c_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$;
/** @constructor */
function $h_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$() {
}
export { $h_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$ as $h_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$ };
$h_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$.prototype = $p;
$p.aA = (function() {
  if ((!this.aF8)) {
    this.aF7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aF8 = true;
  }
  return this.aF7;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$, "app.data.PurchaseOrderContractData$package$PurchaseOrderNumber$", ({
  EN: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$ as $d_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$ };
var $n_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$;
function $m_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$() {
  if ((!$n_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$)) {
    $n_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$ = new $c_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$();
  }
  return $n_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$;
}
export { $m_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$ as $m_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$ };
//# sourceMappingURL=app.data.-Purchase-Order-Contract-Data$package$-Purchase-Order-Number$.js.map
